<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "LineEchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "",
    },
    seriesName: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    legendData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      const that = this;
      const total = 0;
      const option = {
        backgroundColor: "transparent",
        title: {
          text: this.title,

          x: "4%",

          textStyle: {
            color: "#fff",
            fontSize: "22",
          },
        },
        grid: {
          left: "5%",
          right: "10%",
          top: "20%",
          bottom: "15%",
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            var result = params[0].name + "<br>";
            params.forEach(function (item) {
              result +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                item.color +
                '"></span>';
              result +=
                item.seriesName +
                ": " +
                item.data +
                " " +
                that.unit +
                "</span><br>";
            });
            return result;
          },
        },
        xAxis: [
          {
            name: this.xAxisName,
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#85C1D9",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#8BC4F2",
              margin: 6,
            },
            splitLine: {
              show: false,
            },
            boundaryGap: ["5%", "5%"],
            data: this.chartData.xData,
          },
        ],
        yAxis: [
          {
            name: this.yAxisName,
            type: "value",
            axisLabel: {
              color: "#8BC4F2",
              margin: 6,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#85C1D9",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#355C84",
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            name: this.seriesName,
            type: "line",
            stack: "总量",
            symbolSize: 6,
            itemStyle: {
              color: "#55EFF1",
              borderColor: "#55EFF1",
              borderWidth: 2,
            },
            data: this.chartData.yData,
          },
        ],
      };

      this.chart.setOption(option);
    },
  },
};
</script>
